import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'
import { decodeEntities } from '../../lib/stringHelperFunctions'
import Typography from '@ntuctech/devex-tangram/Typography'

const TableContainer = styled.ul`
  border: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  border-radius: 4px;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0.5rem 1rem 0;
  }
`

const Item = styled.li`
  display: flex;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: ${defaultTheme.ColorBaseMineShaft700};
  border-top: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  &:nth-child(even) {
    background-color: ${defaultTheme.ColorBaseMineShaft50};
  }
  &:first-child {
    font-weight: bold;
    border-top: none;
  }
`

const ColRight = styled(Typography)`
  margin-left: auto;
`

export const HtmlTableAttribute = ({ metadata }) => {
  const tableRows = []
  const rows = metadata.value.split(
    /<tr>|<\/tr>|<table {2}border='1'>|<\/table>/
  )
  rows.forEach(row => {
    if (row) {
      const temp = row.split(/<th>|<\/th>|<td>|<\/td>/)
      const col1 = temp[1]
      const col2 = temp[3]
      if (col1 && col2) {
        const redundantTags = /<[^>]*>|<\/[^>]*>/g
        tableRows.push([
          col1.replace(redundantTags, ''),
          col2.replace(redundantTags, ''),
        ])
      }
    }
  })

  return (
    <TableContainer>
      {tableRows.map((value, index) => {
        return (
          <Item key={index} data-testid={`row_${index}`}>
            <Typography variant={index === 0 ? 'bodySBold' : 'bodyS'}>
              {decodeEntities(value[0])}
            </Typography>
            <ColRight variant={index === 0 ? 'bodySBold' : 'bodyS'}>
              {decodeEntities(value[1])}
            </ColRight>
          </Item>
        )
      })}
    </TableContainer>
  )
}
